import { RichText } from '@wordpress/block-editor';
import './style.css';

wp.blocks.registerBlockType('blank/project-list', {
    title: 'Project List',
    category: 'widgets',
    icon: 'list-view',

    edit: () => {
        const projects = wp.data.useSelect((select) => {
            return select('core').getEntityRecords('postType', 'projects', { per_page: 100 });
        }, []);

        if (!projects) {
            return <p>Loading...</p>;
        }

        const formattedDate = (timestamp) => {
            const date = new Date(timestamp);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            return `[ ${day}.${month} ]`;
        }

        return (
            <div>
                <div className="project-list--text">
                    {projects.map((project) => (
                        <div key={project.id} className="project-item">
                            <div className="project-date">{formattedDate(project.date)} <RichText.Content tagName="span" value={project.title.rendered} /></div>
                        </div>
                    ))}
                </div>
            </div>
        );
    },
    save: () => {
        return null;
    },
});
